import React, { useState } from 'react'
import { portal } from '../portalApi.js'

// 관리자가 로컬 계정을 만들면 임시 비밀번호(must_change_password=1)로 발급됨 —
// 첫 로그인 시 반드시 이 화면을 거쳐야 앱에 들어갈 수 있음.
export default function ChangePassword({ user, onChanged }) {
  const [pw1, setPw1] = useState('')
  const [pw2, setPw2] = useState('')
  const [err, setErr] = useState('')
  const [busy, setBusy] = useState(false)

  const submit = async (e) => {
    e.preventDefault()
    if (busy) return
    if (pw1.length < 8) { setErr('비밀번호는 8자 이상이어야 합니다'); return }
    if (pw1 !== pw2) { setErr('두 비밀번호가 서로 다릅니다'); return }
    setBusy(true); setErr('')
    try {
      await portal.post('/api/auth/change-password', { newPassword: pw1 })
      onChanged({ ...user, mustChangePassword: false })
    } catch (ex) {
      setErr(ex.message)
    } finally {
      setBusy(false)
    }
  }

  return (
    <div className="login-wrap">
      <form className="login-card" onSubmit={submit}>
        <div className="login-title">비밀번호 변경</div>
        <div className="login-sub">임시 비밀번호로 로그인하셨습니다. 계속 진행하려면 새 비밀번호를 설정해주세요.</div>
        <input placeholder="새 비밀번호 (8자 이상)" type="password" value={pw1}
          onChange={(e) => setPw1(e.target.value)} autoFocus />
        <input placeholder="새 비밀번호 확인" type="password" value={pw2}
          onChange={(e) => setPw2(e.target.value)} />
        {err && <div className="login-err">{err}</div>}
        <button className="btn" type="submit" disabled={busy || !pw1 || !pw2}>
          {busy ? '저장 중…' : '비밀번호 변경'}
        </button>
      </form>
    </div>
  )
}
